/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import icon from 'flarum/common/helpers/icon';

export default class AchievementCategoryName extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	static initAttrs(attrs) {
		attrs.collapsed = attrs.collapsed || (() => {});
	}

	view() {
		const { category, collapsed } = this.attrs;

		return (
			<div className="AchievementCategoryName" onclick={() => collapsed(!collapsed())}>
				{category?.image() ? (
					<div
						className="AchievementCategoryName-image"
						style={{
							'--category-image': `url("${category?.image()}")`,
						}}
					></div>
				) : category?.icon() ? (
					icon(category?.icon())
				) : null}{' '}
				{category.name()}
			</div>
		);
	}
}
